import React, { useEffect, useState } from 'react';
import EditableSection from 'components/v2/EditableSection';
import { useTranslation } from 'react-i18next';
import { payloadMappingOnlyForChanges } from '../shipper/billingv2/utils';
import { useParams } from 'react-router-dom';
import TextField from 'components/v2/forms/TextField';
import DescriptionListItem from 'components/v2/DescriptionListItem';
import Label from 'components/v2/forms/Label';
export const AccountingSummary = ({ fields, }) => {
    const { t } = useTranslation();
    return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
        React.createElement(DescriptionListItem, { label: t('NETSUITE_ID'), className: "mb-4" }, fields === null || fields === void 0 ? void 0 : fields.net_suite_id),
        React.createElement(DescriptionListItem, { label: t('CRM_MAPPING_ID'), className: "mb-4" }, fields === null || fields === void 0 ? void 0 : fields.crm_mapping_id)));
};
export const AccountingForm = ({ onChange, fields, saving, onSaveCarrier, onSaveSuccess, onSaveFail, }) => {
    const { t } = useTranslation();
    const saveForm = async () => {
        try {
            await onSaveCarrier();
            onSaveSuccess(fields);
        }
        catch (e) {
            onSaveFail();
        }
    };
    useEffect(() => {
        if (saving) {
            saveForm();
        }
    }, [saving]);
    return (React.createElement("div", { className: "grid grid-cols-2 gap-4" },
        React.createElement("div", null,
            React.createElement(Label, { htmlFor: "netsuiteId" }, t('NETSUITE_ID')),
            React.createElement(TextField, { className: "mt-1", value: fields === null || fields === void 0 ? void 0 : fields.net_suite_id, onChange: (val) => onChange('net_suite_id', val) })),
        React.createElement("div", null,
            React.createElement(Label, { htmlFor: "crm_mapping_id" }, t('CRM_MAPPING_ID')),
            React.createElement(TextField, { value: fields === null || fields === void 0 ? void 0 : fields.crm_mapping_id, className: "mt-1", onChange: (val) => onChange('crm_mapping_id', val) }))));
};
const AccountSettings = ({ canEdit, className, data = null, onUpdateCarrier, }) => {
    const { t } = useTranslation();
    const { id: userId } = useParams();
    const [initialData, setInitialData] = useState(data);
    const [accountingData, setAccountingData] = useState(data);
    const handleSave = async () => {
        const payload = payloadMappingOnlyForChanges(initialData, accountingData);
        onUpdateCarrier(userId, payload);
    };
    const onChange = (field, value) => {
        setAccountingData((prev) => (Object.assign(Object.assign({}, prev), { [field]: value.trim() })));
    };
    const handleAfterSave = (onSaveSuccess) => {
        return (updatedData = {}) => {
            setInitialData((prev) => (Object.assign(Object.assign({}, prev), updatedData)));
            onSaveSuccess();
        };
    };
    return (React.createElement(EditableSection, { className: className, title: t('ACCOUNTING'), canEdit: canEdit, onSave: handleSave }, (editMode, saving, onSaveSuccess, onSaveFail) => editMode ? (React.createElement(AccountingForm, { fields: accountingData, saving: saving, onChange: onChange, onSaveSuccess: handleAfterSave(onSaveSuccess), onSaveFail: () => onSaveFail(), onSaveCarrier: async () => await handleSave() })) : (React.createElement(AccountingSummary, { fields: initialData }))));
};
export default AccountSettings;
